import React, { useCallback, useEffect } from 'react';
import { Modal, Tappable } from '@vectord/components';
import { batch, useDispatch, useSelector } from 'react-redux';
import cogoToast from 'cogo-toast';

import { DEFAULT_ERROR_MESSAGE } from 'data/defaultErrorMessage';
import {
  selectedSuperBatchModuleSelector,
  setSelectedSuperBatchModule,
  setUpdateSuperBatchModuleModalState,
  updateSuperBatchModuleStatusModalStateSelector,
  useUpdateMenteeModuleStatusMutation,
} from 'features/moduleManagement';
import GlobalLoader from 'components/GlobalLoader';

function UpdateSuperBatchModuleStatusModal() {
  const dispatch = useDispatch();
  const isModalOpen = useSelector(
    updateSuperBatchModuleStatusModalStateSelector
  );
  const selectedMenteeModule = useSelector(selectedSuperBatchModuleSelector);
  const [updateMenteeModuleStatus, { error, isSuccess, isLoading }] =
    useUpdateMenteeModuleStatusMutation();

  const { updatedStatus, status } = selectedMenteeModule || {};

  const handleOnClose = useCallback(() => {
    batch(() => {
      dispatch(setUpdateSuperBatchModuleModalState(false));
      dispatch(setSelectedSuperBatchModule(null));
    });
  }, [dispatch]);

  const handleConfirm = useCallback(() => {
    updateMenteeModuleStatus(selectedMenteeModule);
  }, [selectedMenteeModule, updateMenteeModuleStatus]);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Status changed successfully!');
      batch(() => {
        dispatch(setUpdateSuperBatchModuleModalState(false));
        dispatch(setSelectedSuperBatchModule(null));
      });
    }
  }, [dispatch, isSuccess]);

  useEffect(() => {
    if (error) {
      cogoToast.error(error?.data?.message || DEFAULT_ERROR_MESSAGE);
    }
  }, [error]);

  return (
    <Modal
      isOpen={isModalOpen}
      unMountOnClose
      onClose={handleOnClose}
      withoutHeader
      className="p-xs"
      canClose={!isLoading}
    >
      <GlobalLoader isVisible={isLoading} />
      <div className="bold dark">Confirm Status Change</div>
      <div>
        Are you sure you want to change the status of this module from {status}{' '}
        to {updatedStatus}?
      </div>
      <div className="m-t-xxs row">
        <Tappable
          onClick={handleConfirm}
          disabled={isLoading}
          className="btn btn-primary btn-long m-r-xs"
        >
          Yes
        </Tappable>
        <Tappable
          onClick={handleOnClose}
          disabled={isLoading}
          className="btn btn-inverted btn-long"
        >
          No
        </Tappable>
      </div>
    </Modal>
  );
}

export default UpdateSuperBatchModuleStatusModal;
